import { removeUndefinedFields } from "../helper";

export const QUESTIONS = [
  {
    label: "Oil filter Make",
    options: [
      {
        label: "Simpson Recommended Filter used",
        apiOptionKey: "simpsonRecommendedFilterUsed",
      },
      {
        label: "Non- Recommended Filter Used",
        apiOptionKey: "nonRecommendedFilterUsed",
      },
    ],
  },

  {
    label: "Oil Details",
    options: [
      {
        label: "Oil Grade",
        type: "INPUT",
        apiOptionKey: "oilGrade",
      },
      {
        label: "Oil Make",
        type: "INPUT",
        apiOptionKey: "oilMake",
      },
    ],
  },

  {
    label: "Oil condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q2o1",
      },
      {
        label: "Found Diesel Mix",
        apiOptionKey: "foundDieselMix",
      },
      {
        label: "Found Greasy",
        apiOptionKey: "foundGreasy",
      },
      {
        label: "Found Blackish",
        apiOptionKey: "foundBlackish",
      },
      {
        label: "Found Coolant Mix",
        apiOptionKey: "foundCoolantMix",
      },
    ],
  },
  {
    label:
      "Oil Level in Sump (Mark the line with corresponding ‘X’ in dipstick)",
    apiKey: "oilLevelInSump",
    type: "INPUT",
    options: [],
  },
  {
    label: "Oil Pressure Observed (Bar / Kg/Cm2)",
    apiKey: "oilPressureObservedInBarPerKgPerCmSquare",
    type: "INPUT",
    keyboardType: "numeric",
    options: [],
  },
  {
    label: "Oil Filter Condition	",
    options: [
      { label: "Found ok", apiOptionKey: "q5o1" },
      { label: "Found Clogged", apiOptionKey: "foundClogged" },
      { label: "Found Oil leakage", apiOptionKey: "foundOilLeakage" },
      { label: "Found damaged", apiOptionKey: "foundDamaged" },
    ],
  },
  {
    label: "Oil Cooler Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      { label: "Found Clogged", apiOptionKey: "q6o2" },
      { label: "Found Oil leakage", apiOptionKey: "q6o3" },
      { label: "Found damaged", apiOptionKey: "q6o4" },
    ],
  },
];

export const mappingDetailsToUILubeSystem = (details) => {
  const {
    oilFilterMake = {},
    oilGrade,
    oilMake,
    oilCondition = {},
    oilLevelInSump,
    oilPressureObservedInBarPerKgPerCmSquare,
    oilFilterCondition = {},
    oilCoolerCondition = {},
  } = details;

  let responseDetails = {
    simpsonRecommendedFilterUsed: oilFilterMake.simpsonRecommendedFilterUsed,
    nonRecommendedFilterUsed: oilFilterMake.nonRecommendedFilterUsed,

    oilGrade,
    oilMake,

    q2o1: oilCondition.foundOk,
    foundDieselMix: oilCondition.foundDieselMix,
    foundGreasy: oilCondition.foundGreasy,
    foundBlackish: oilCondition.foundBlackish,
    foundCoolantMix: oilCondition.foundCoolantMix,

    oilLevelInSump,
    oilPressureObservedInBarPerKgPerCmSquare:
      oilPressureObservedInBarPerKgPerCmSquare?.toString(),

    q5o1: oilFilterCondition.foundOk,
    foundClogged: oilFilterCondition.foundClogged,
    foundOilLeakage: oilFilterCondition.foundOilLeakage,
    foundDamaged: oilFilterCondition.foundDamaged,

    q6o1: oilCoolerCondition.foundOk,
    q6o2: oilCoolerCondition.foundClogged,
    q6o3: oilCoolerCondition.foundOilLeakage,
    q6o4: oilCoolerCondition.foundDamaged,
  };

  return responseDetails;
};

export const infantChecklistLubeSystem = (payload) => {
  const {
    simpsonRecommendedFilterUsed,
    nonRecommendedFilterUsed,
    oilGrade,
    oilMake,

    q2o1,
    foundDieselMix,
    foundGreasy,
    foundBlackish,
    foundCoolantMix,

    oilLevelInSump,
    oilPressureObservedInBarPerKgPerCmSquare,
    q5o1,
    foundClogged,
    foundOilLeakage,
    foundDamaged,
    q6o1,
    q6o2,
    q6o3,
    q6o4,
  } = payload;

  let requestPayload = {};

  if (simpsonRecommendedFilterUsed || nonRecommendedFilterUsed) {
    requestPayload.oilFilterMake = {
      simpsonRecommendedFilterUsed,
      nonRecommendedFilterUsed,
    };
  }

  if (oilGrade) {
    requestPayload.oilGrade = oilGrade;
  }

  if (oilMake) {
    requestPayload.oilMake = oilMake;
  }

  if (
    q2o1 ||
    foundDieselMix ||
    foundGreasy ||
    foundBlackish ||
    foundCoolantMix
  ) {
    requestPayload.oilCondition = {
      foundOk: q2o1,
      foundDieselMix,
      foundGreasy,
      foundBlackish,
      foundCoolantMix,
    };
  }

  if (oilLevelInSump) {
    requestPayload.oilLevelInSump = oilLevelInSump;
  }

  if (oilPressureObservedInBarPerKgPerCmSquare) {
    requestPayload.oilPressureObservedInBarPerKgPerCmSquare =
      +oilPressureObservedInBarPerKgPerCmSquare;
  }

  if (q5o1 || foundClogged || foundOilLeakage || foundDamaged) {
    requestPayload.oilFilterCondition = {
      foundOk: q5o1,
      foundClogged,
      foundOilLeakage,
      foundDamaged,
    };
  }

  if (q6o1 || q6o2 || q6o3 || q6o4) {
    requestPayload.oilCoolerCondition = {
      foundOk: q6o1,
      foundClogged: q6o2,
      foundOilLeakage: q6o3,
      foundDamaged: q6o4,
    };
  }
  const cleanedPayload = removeUndefinedFields(requestPayload);
  return cleanedPayload;
};
